import React from 'react';
import {withNavigationWatcher} from '../../../contexts/navigation';
import {Redirect} from 'react-router-dom';
import {
ProductsPage,
PresetGroupsPage,
InventoriesPage
} from '../../../pages/products/index';


const Home = () =>{
    return(<Redirect to="/products/list"/>);
}

const ProductsRoutes = [
    {
        path: '/products',
        component: Home
    }
    ,{
        path: '/products/list',
        component: ProductsPage
    },
    {
        path: '/products/producttype',
        component: PresetGroupsPage
    },
    /*
    {
        path: '/products/inventory',
        component: InventoriesPage
    }
    */
];

export default ProductsRoutes.map(route => {
    return {
        ...route,
        component: withNavigationWatcher(route.component)
    };
});






